var _path, _ellipse, _ellipse2, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBola(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 1365,
    viewBox: "0 0 145 1365",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.3751 1232.38L71.375 0",
    stroke: "#BFB1AF",
    strokeWidth: 4.95097
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.408,
    cy: 1298.39,
    rx: 72.408,
    ry: 66.2192,
    fill: "#F44669"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.502,
    cy: 1275.91,
    rx: 16.9158,
    ry: 15.6781,
    fill: "url(#paint0_radial_119_1638)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 53.6328,
    y: 1208.24,
    width: 36.3071,
    height: 28.0555,
    rx: 3.30065,
    fill: "url(#paint1_radial_119_1638)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_119_1638",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.502 1275.91) rotate(90) scale(15.6781 16.9158)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_119_1638",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71.7864 1222.27) rotate(90) scale(14.0278 18.1536)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFB1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8BF03"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBola);
export default __webpack_public_path__ + "static/media/bola.ca22ff56f27027e528a4b296f1afc4a7.svg";
export { ForwardRef as ReactComponent };